import "./style.scss";

import { Box, Container, Grid } from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import React from "react";
import { useHistory } from "react-router-dom";

import EventButton from "../../components/EventButton";
import EventEmptyView from "../../components/EventEmptyView";
import EventSectionTitle from "../../components/EventSectionTitle";
// ...
import Page from "../../components/Page";
import useStages from "../../hooks/useStages";
import { getDefaults } from "../../utils/defaults";
import StageCard from "./components/StageCard";
import useEventPack from "../../hooks/useEventPack";

const EventStage = () => {
  const history = useHistory();
  const dValues = getDefaults();
  const isMobile = useMediaQuery("(max-width:850px)");
  // ...
  const { isLoading, data: stages, onUpdate, onDelete } = useStages();
  const { packData } = useEventPack();
  // ...
  const canCreateStage = () => {
    if(!stages || !stages.length || (stages.length<2 && packData.type=="starter") || (stages.length<4 && packData.type=="business") || packData.type=="prestige"){
      return true;
    }
    return false;
  }
  // ...
  const onAddStage = async () => {
    const { stageId, error } = await onUpdate({ card: dValues.stageCard });
    // ...
    if (error) return;
    if (parseInt(stageId)) {
      history.push(`/stages-schedules/${stageId}`);
    }
  };
  // ...
  return (
    <Page title="Stages and schedules">
      <Container>
        <Box>
          <EventSectionTitle
            title="Event Agenda"
            subTitle="Create agenda and sessions"
            src="/static/setup/title/stages.svg"
          />

          {stages.length > 0 && (
            <EventSectionTitle
              title="View virtual space"
              subTitle="Review and manage virtual spaces"
            >
              <EventButton disabled={!canCreateStage()} isLoading={isLoading} handler={() => onAddStage()}>
                {isMobile && "New"}
                {!isMobile && "New virtual space"}
              </EventButton>
            </EventSectionTitle>
          )}

          {stages.length === 0 && (
            <EventEmptyView
              src="/static/setup/empty/stages.svg"
              title="Add new schedule"
              desc="Manage event scenes and multiple schedules"
              btnLabel="Add new virtual space"
              handler={() => onAddStage()}
              isLoading={isLoading}
            />
          )}

          {stages.length > 0 && (
            <Box className="EventStages">
              <Box className="EventStages__cards">
                <Grid container spacing={isMobile ? 2 : 4}>
                  {stages.map((stage, idx) => (
                    <Grid key={idx} item xs={6} sm={6} md={3}>
                      <StageCard
                        key={idx}
                        data={stage}
                        isLoading={isLoading}
                        onDelete={onDelete}
                      />
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Box>
          )}
        </Box>
      </Container>
    </Page>
  );
};

export default EventStage;
